import * as React from 'react';

import { ActionOverflow } from '@coursera/cds-core';
import { EditIcon, TrashIcon } from '@coursera/cds-icons';

import { editDeleteLabels, rowActionsHoC } from 'bundles/staff-management/src/StaffTable/RowActions';
import type { Props } from 'bundles/staff-management/src/StaffTable/RowActions';
import { redesignStaffManagement } from 'bundles/staff-management/src/utils/epic';

import _t from 'i18n!nls/staff-management';

interface DropdownItem {
  label: string;
  onClick: () => void;
  icon: React.ReactElement;
}

export const RowActions = ({ delStaff, delTypeRoles, edit, type }: Props) => {
  const delLabel = _t('Remove staff');
  const { editLabel, delTypeRolesLabel } = editDeleteLabels(type);

  const actionOverflowItems: DropdownItem[] = [];
  if (edit) {
    actionOverflowItems.push({
      label: editLabel,
      onClick: edit,
      icon: <EditIcon />,
    });
  }

  if (delTypeRoles) {
    actionOverflowItems.push({
      label: delTypeRolesLabel,
      onClick: delTypeRoles,
      icon: <TrashIcon />,
    });
  }

  if (delStaff) {
    actionOverflowItems.push({
      label: delLabel,
      onClick: delStaff,
      icon: <TrashIcon />,
    });
  }

  if (actionOverflowItems.length === 0) {
    return null;
  }

  return (
    <ActionOverflow size="small">
      {actionOverflowItems.map(({ label, icon, onClick }) => (
        <ActionOverflow.Item icon={redesignStaffManagement() ? undefined : icon} key={label} onClick={onClick}>
          {label}
        </ActionOverflow.Item>
      ))}
    </ActionOverflow>
  );
};

export default rowActionsHoC(RowActions);
